import { ColorOptions, TextInputNewProps } from '@jfs/ui-new'
import { Colors } from '../../util/util'

export const styles = (isEmail: boolean) => {
  return {
    textInput: {
      type: 'body12',
      padding: isEmail ? 1 : 0,
      focusBorderColor: 'TRANSPARENT',
      borderColor: 'TRANSPARENT',
      labelPaddingBottom: 8,
      fontFamily: 'jiotype-bold',
      labelColor: 'BLACK_21',
      labelFontSize: 12,
      fontSize: 11,
      selectionColor: 'BLUE',
      bgColor: 'TRANSPARENT',
      placeholderTextColor: Colors.LABEL_GREY as ColorOptions,
      color: Colors.FONT_BLACK as ColorOptions,
    } as TextInputNewProps,
  }
}
